import clsx from "clsx"
import { FC } from "react"
import { ISourceOption } from "."
import styles from "./SourceOption.module.scss"

export const SourceOption: FC<ISourceOption> = ({
  onChange,
  isChosen,
  text,
  className,
  ...rest
}) => {
  return (
    <button
      type="button"
      aria-pressed={isChosen}
      className={clsx(
        styles.SourceOption,
        { [styles.isChosen]: isChosen },
        className
      )}
      onClick={onChange}
      {...rest}
    >
      <span className={styles.SourceOption_title}>{text}</span>
      <span className={styles.SourceOption_button}>
        <span />
      </span>
    </button>
  )
}
